import React from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { MenuComponent } from '@vedmarket/ui-kit'

import './cabinet-menu.scss'

const CabinetMenu = (props: CommonCabinetMenuProps) => {
  const location = useLocation()
  const navigate = useNavigate()

  return (
    <div className='cabinet-menu'>
      <MenuComponent {...props} location={location} navigate={navigate} />
    </div>
  )
}

export default CabinetMenu
